import axios from 'axios';
import cfg from '../../config/app';

// 避免重复定义拦截器（移到类外部）
axios.interceptors.response.use(
	(response) => {
		// 如果是 Blob 响应，直接返回，不检查 code
		if (response.config.responseType === 'blob') {
			return response;
		}
		// 普通 JSON 响应检查 code
		if (response.data.code === 401) {
			// 处理登录超时
			console.warn('登录已过期，请重新登录');
			// 例如：跳转到登录页
			// window.location.href = '/login';
		} else if (response.data.code === 1345 || response.data.code === 1346) {
			// 处理其他错误
			console.warn('请求错误，错误码：', response.data.code);
		}
		return response;
	},
	(error) => {
		return Promise.reject(error);
	}
);

export class HttpUtils {
	// GET 请求
	static get(url, params = {}, config = {}) {
		return this.http('GET', url, params, config);
	}

	// POST 请求
	static post(url, data = {}, config = {}) {
		return this.http('POST', url, data, config);
	}

	// PUT 请求
	static put(url, data = {}, config = {}) {
		return this.http('PUT', url, data, config);
	}

	// DELETE 请求
	static delete(url, params = {}, config = {}) {
		return this.http('DELETE', url, params, config);
	}

	// 通用 HTTP 方法
	static http(method, url, data, config = {}) {
		url = cfg.urls + url;

		// 合并 headers（如果是 FormData，不设置 Content-Type）
		const headers = {
			...config.headers, // 允许外部覆盖 headers
		};

		// 如果是 FormData，不设置 Content-Type（浏览器会自动处理）
		if (!(data instanceof FormData)) {
			headers['Content-Type'] = 'application/json;charset=UTF-8';
		}

		// 添加 Token
		const token = sessionStorage.getItem('token');
		if (token) {
			headers['Authorization'] = 'Bearer ' + token;
		}

		return axios({
			method,
			url,
			params: method === 'GET' ? data : undefined,
			data: method !== 'GET' ? data : undefined, // 直接传入 FormData 对象
			headers,
			responseType: config.responseType || 'json',
			...config,
		});
	}
}